module.exports = __webpack_public_path__ + "img/LV2@3x.a81dffc5.png";